import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useMemo } from 'react';

const Context = createContext({
  formFactor: 'phone',
  hasWebpSupport: false,
  isBot: false,
  RouterLink: undefined,
  rootNodeId: undefined
});
const AppContext = ({
  children,
  formFactor,
  hasWebpSupport,
  isBot,
  isRouterLinkNextLink,
  RouterLink,
  rootNodeId
} = {
  formFactor: 'phone',
  hasWebpSupport: false,
  isBot: false,
  isRouterLinkNextLink: false,
  RouterLink: undefined,
  rootNodeId: undefined
}) => {
  const [initial] = useState(() => ({
    formFactor,
    hasWebpSupport,
    isBot,
    isRouterLinkNextLink,
    RouterLink,
    rootNodeId
  }));
  const contextValue = useMemo(() => ({
    formFactor: formFactor !== null && formFactor !== void 0 ? formFactor : initial.formFactor,
    hasWebpSupport: hasWebpSupport !== null && hasWebpSupport !== void 0 ? hasWebpSupport : initial.hasWebpSupport,
    isBot: isBot !== null && isBot !== void 0 ? isBot : initial.isBot,
    isRouterLinkNextLink: isRouterLinkNextLink !== null && isRouterLinkNextLink !== void 0 ? isRouterLinkNextLink : initial.isRouterLinkNextLink,
    RouterLink: RouterLink !== null && RouterLink !== void 0 ? RouterLink : initial.RouterLink,
    rootNodeId: rootNodeId !== null && rootNodeId !== void 0 ? rootNodeId : initial.rootNodeId
  }), [formFactor, hasWebpSupport, initial.formFactor, initial.hasWebpSupport, initial.isBot, initial.isRouterLinkNextLink, initial.RouterLink, initial.rootNodeId, isBot, isRouterLinkNextLink, RouterLink, rootNodeId]);
  return jsx(AppContext.Context.Provider, Object.assign({
    value: contextValue
  }, {
    children: children
  }), void 0);
};
AppContext.Context = Context;
AppContext.displayName = 'AppContext';

export { AppContext };
